export const isAdriagate =
  window.location.origin.includes('adriagate') ||
  //window.location.origin.includes('localhost') ||
  window.localStorage.getItem('CUSTOMER_ID') === '1011' ||
  window.localStorage.getItem('CUSTOMER_ID') === '276';

// adriagate link: Smjestaj- + šifra objekta + # + oznaka smještajne jedinice (npr. Smjestaj-V4241#K1)
export const getAdriagateObjectUrl = (objectCode?: string, unitTag?: string) =>
  `https://www.adriagate.com/Hrvatska-hr/Smjestaj-${objectCode ?? ''}${
    unitTag ? `#${unitTag}` : ''
  }`;
